import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Flex from "../flex";
import MenuItem from "./MenuItem";

const DropdownContainer = styled(Flex)`
  display: flex;
  width: 298px;
  padding: 1px 0 16px 0;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.15);
  position: absolute;
  top: 100%;
  z-index: 1000;
  margin-top: 4px;
`;

const SaveButtonContainer = styled(Flex)`
  padding: 12px 24px 0px 24px;
  width: 100%;
`;

const SaveButton = styled.button`
  display: flex;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  border: none;
  background: ${({ theme }) => theme.colors.primary500};
  color: white;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  height: 40px;
  width: 100%;
  border-radius: 8px;

  &:hover {
    background: ${({ theme }) => theme.colors.primary400};
  }

  &:disabled {
    background: #dee5ec;
    cursor: not-allowed;
  }
`;

const PlaceholderText = styled.div`
  padding: 16px 24px;
  color: #6e6e6e;
  font-size: 14px;
  text-align: center;
`;

const FilterDropdown = ({
  options,
  selectedValue,
  onValueChange,
  onSave,
  position = "left",
  placeholder
}) => {
  const handleItemClick = value => {
    onValueChange(value);
  };

  return (
    <DropdownContainer position={position}>
      {placeholder ? (
        <PlaceholderText>{placeholder}</PlaceholderText>
      ) : (
        options.map((option, index) => (
          <MenuItem
            key={option.value}
            label={option.label}
            value={option.value}
            isSelected={selectedValue === option.value}
            onClick={() => handleItemClick(option.value)}
            isFirst={index === 0}
            isLast={index === options.length - 1}
          />
        ))
      )}

      <SaveButtonContainer>
        <SaveButton onClick={onSave} disabled={!options.length}>
          {"Save"}
        </SaveButton>
      </SaveButtonContainer>
    </DropdownContainer>
  );
};

FilterDropdown.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  ).isRequired,
  selectedValue: PropTypes.string,
  onValueChange: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  position: PropTypes.string,
  placeholder: PropTypes.string
};

export default FilterDropdown;
